import { createRouter, createWebHistory } from 'vue-router'
import UpdateHtml from '../views/UpdateHtml.vue'
import CompareHtml from '../views/CompareHtml.vue'
import UserLogin from '../views/UserLogin.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: UserLogin,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'compare',
    component: CompareHtml,
    meta: { requiresAuth: true }
  },
  {
    path: '/edit',
    name: 'updateHtml',
    component: UpdateHtml,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // 检查token是否有效（简单检查：是否存在且不为空）
  const hasValidToken = token && token.trim() !== ''
  
  if (to.meta.requiresAuth && !hasValidToken) {
    // 需要认证但没有有效token，跳转到登录页
    next('/login')
  } else if (to.path === '/login' && hasValidToken) {
    // 已登录用户访问登录页，跳转到主页
    next('/')
  } else {
    next()
  }
})

export default router 